module.exports = __webpack_public_path__ + "static/media/woman1.9e19f112.jpg";